module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (252).d26f860e.jpg";